import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#7C4DFF" },
            secondary: { main: "#00BCD4" },
            error: { main: "#EF5350" },
            success: { main: "#4CAF50" },
            background: { default: "#F5F5F9", paper: "#FFFFFF" },
          }
        : {
            primary: { main: "#B388FF" },
            secondary: { main: "#4DD0E1" },
            error: { main: "#EF5350" },
            success: { main: "#66BB6A" },
            background: { default: "#0B1120", paper: "#162031" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: { disableElevation: true },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: "1px solid",
            borderColor: mode === "light" ? "#E8E8EE" : "#1E2D45",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            "&.Mui-selected": {
              backgroundColor:
                mode === "light"
                  ? "rgba(124, 77, 255, 0.08)"
                  : "rgba(179, 136, 255, 0.12)",
              color: mode === "light" ? "#7C4DFF" : "#B388FF",
              "&:hover": {
                backgroundColor:
                  mode === "light"
                    ? "rgba(124, 77, 255, 0.12)"
                    : "rgba(179, 136, 255, 0.16)",
              },
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 600 } },
      },
    },
  });
}
